import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Breadcrumbs.css';
import Link from '../Link';

/**
 * Видимые хлебные крошки.
 *
 * BreadcrumbList в JSON-LD был и раньше, но разметка без видимого
 * соответствия на странице — это разметка, которой Google верит хуже.
 * Последний элемент — текущая страница, ссылкой не делается.
 *
 * items: [{ name, url }], у последнего url можно не указывать.
 */
function Breadcrumbs({ items }) {
	return (
		<nav className={s.root} aria-label="Breadcrumb">
			<ol>
				{items.map((item, i) => {
					const last = i === items.length - 1;

					return (
						<li key={item.name}>
							{last || !item.url ? (
								<span className={s.current}>{item.name}</span>
							) : (
								<Link to={item.url}>{item.name}</Link>
							)}
						</li>
					);
				})}
			</ol>
		</nav>
	);
}

Breadcrumbs.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			url: PropTypes.string,
		}),
	).isRequired,
};

export default withStyles(s)(Breadcrumbs);
